<template>
  <base-dialog-button :isOpen="dialogOpen" @closeDialog="toggleDialog" :ariaLabel="$t('configurations.link_group')">
    <template slot="header">
      <div class="h-16 bg-secondary flex items-center justify-between text-white px-4">
        <div class="flex items-center">
          <h2 class="font-bold ml-2">{{$t('configurations.link_group')}}</h2>
        </div>
        <span class="cursor-pointer" @click="toggleDialog">
          <base-button-icon name="cross" size="xs" iconSize="sm" mode="secondary" />
        </span>
      </div>
    </template>
    <template slot="main">
      <div 
        class="form-wrapper p-4 overflow-x-hidden"
        ref="containerSelect"
        style="max-height: 40vh"
        :style="{'height':heightContainerSelect}"
        >
        <el-form
          ref="ruleForm"
        >
          <div class="">
            <div ref="selectRef">

              <accessible-el-select
                prop="groupId"
                v-model="form.groupId"
                isMultiple
                group
                :options="listaGroupsGrouping"
                id-prefix="neolinkgroupsdialog"
                :isDisabled="isLoadingSelect"
              >
                <template #label>
                  {{$t('app.groups')}}
                </template>
              </accessible-el-select>

            </div>
            <span v-if="processMessageVincularRepartoActive" v-html="processMessageVincularReparto" class="w-full dialog-body-content p-1 dark:text-darkblue-200 inline-block word-break-n"/>
          </div>
        </el-form>
      </div>
    </template>
    <template slot="footer">
        <base-button mode="secondary-phantom-blue"
            class="w-full"
          v-if="!isAllSelected" 
          :disabled="!isLoadedData || isLoadingSelect || isEmptyList" 
          :text="$t('app.select_all')" 
          @click="handleSelectAll" 
          :loading="isLoadingSelect"
          />
        <base-button v-else :text="$t('app.unselect_all')" mode="secondary-phantom-blue"
            class="w-full"
          @click="handleUnSelectAll"
          :loading="isLoadingSelect"
          :disabled="isLoadingSelect || isEmptyList"
          />
          <div class="w-48 "></div>
        <base-button @click="toggleDialog" mode="secondary-phantom-blue" :text="$t('app.cancel')" 
            class="w-full"
          :loading="isLoadingSelect"
          :disabled="isLoadingSelect"/>
        <base-button mode="secondary-phantom-blue" class="w-full" :text="$t('app.accept')" @click="apply" 
          :loading="isLoadingSelect"
          :disabled="isLoadingSelect"/>
    </template>
  </base-dialog-button>
</template>

<script>
import BaseDialogButton from './base/BaseDialogButton.vue'
import { getGroupsSimple } from '@/services/configurations/groups/getGroupsSimple'
import AccessibleElSelect from '@/components/elementui/AccessibleElSelect.vue'
import DOMPurify from 'dompurify'

export default
{
  name: 'n-e-o-link-groups-dialog',
  components: {
    BaseDialogButton,
    AccessibleElSelect,
  },
  props: {
    dialogOpen: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      heightSelect: 0,
      heightInput: 64,
      isOpen: this.dialogOpen,
      form: {
        groupId: []
      },
      groups: [],
      isLoadedData: false,
      loadingActionSelect: false,
      loadingActionUnSelect: false,
    }
  },
  mounted: async function () {
    this.isLoadedData = false
    const data = await getGroupsSimple({ idNEO: this.$route.params.id })
    if (data.blnError === true) {
      this.doFeedback(data.msgError + ' [Código de error: ' + data.codError + ']')
    } else {
      data.Respuesta.forEach(row => {
        this.groups.push({ id: row.IdGrupo, value: row.Nombre, group: row.Tipo, idTipo: row.idTipo })
      })
    }
    this.isLoadedData = true
  },
  computed: {
    processMessageVincularReparto () {
      return DOMPurify.sanitize(this.$i18n.t('groups.link_reparto_info'))
    },
    processMessageVincularRepartoActive () {
      return this.groups && this.groups.filter(x => this.form.groupId.includes(x.id)).filter(x => x.idTipo === 3).length > 0
    },
    listaGroupsGrouping () {
      if (!this.isEmptyList) {
        const options = []
        this.groups.forEach(x => {
          if (options.filter(y => y.label === x.group).length === 0) {
            options.push(
              { label: x.group, options: [] }
            )
          }
        })
        this.groups.forEach(x => {
          const index = options.map(x => x.label).indexOf(x.group)
          options[index].options.push(
            {
              value: x.id,
              label: x.value,
            }
          )
        })
        return options.map(group => ({
          label: group.label,
          options: group.options.map(opt => ({ id: opt.value, value: opt.value, name: opt.label }))
        }))
      }
      return []
    },
    isEmptyList: function () {
      return this.groups === undefined || this.groups === null || this.groups.length === 0
    },
    isLoadingSelect: function () {
      return this.loadingActionUnSelect || this.loadingActionSelect
    },
    isAllSelected: function () {
      if (this.groups.length === this.form.groupId.length) return true
      else return false
    },
    heightContainerSelect: function () {
      if (this.heightSelect !== undefined && this.heightSelect !== 0) {
        let heightCalc = this.heightSelect + this.heightInput + 30
        if (heightCalc > 400) heightCalc = 400
        return heightCalc + 'px'
      } else {
        return 'auto'
      }
    },
  },
  methods: {
    onExpand (value) {
      this.onChangeInput()
      if (value) {
        setTimeout(() => {
          const elementsScrollBar = document.getElementsByClassName('el-scrollbar')
          this.heightSelect = elementsScrollBar[elementsScrollBar.length - 1]?.clientHeight
        }, 100)
      } else {
        this.heightSelect = 0
      }
    },
    onChangeInput () {
      setTimeout(() => {
        this.heightInput = this.$refs.selectRef.clientHeight
      }, 100)
    },
    toggleDialog: function () {
      if (this.dialogOpen && this.isLoadingSelect) return
      this.isOpen = !this.isOpen
      this.$emit('toggleDialog')
      this.form.groupId = []
    },
    apply: function () {
      this.isOpen = !this.isOpen
      this.$emit('applyDialog', this.form.groupId)
      this.form.groupId = []
    },
    handleSelectAll: async function () {
      // this.form.location = []
      await this.handleUnSelectAll()
      this.loadingActionSelect = true
      this.groups.forEach(element => {
        setTimeout(() => {
          this.form.groupId.push(element.id)
          if (this.form.groupId.length === this.groups.length) {
            this.loadingActionSelect = false
            this.loadingActionUnSelect = false
          }
        }, 100)
      })
    },
    handleUnSelectAll: async function () {
      this.loadingActionUnSelect = true
      const staticLength = this.form.groupId.length
      for (let index = 0; index < staticLength; index++) {
        setTimeout(() => {
          this.form.groupId.pop()
          if (this.form.groupId.length === 0) this.loadingActionUnSelect = false
        }, 100)
      }
      // this.form.location = []
    }
  }
}
</script>

<style scoped>
.dialog-body-content {
  color: #606266;
  font-size: 14px;
}
</style>
